import { IModel, Collection, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { BaseMultiInputStreamTransformation } from './base-multi-input-stream-transformation';
import { format } from 'app/shared/utils/string.util';
import { DataFlowExpression } from './dataflowexpression';
import { BooleanDataFlowType, StringDataFlowType } from './dataflow-datatype';
import { SortExpression, ISortableTransformation } from './sort-expression';
import { Owned } from '../base/named';
import { Transformation } from './transformation';

@Metamodel.model({
    name: 'lookuptransformation',
    display: [stringResources.DataFlowLookupTransformationLabel, stringResources.DataFlowLookupTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    },
    validator: BaseMultiInputStreamTransformation.prototype.inputStreamValidate
})
export class LookupTransformation extends BaseMultiInputStreamTransformation implements ISortableTransformation {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        constraint: {
            validator: LookupTransformation.validateMultipleRow
        }
    })
    public multipleRow: DataFlowExpression = this.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');

    @Metamodel.attribute({
        constraint: {
            validator: LookupTransformation.validatePickupRow
        }
    })
    public pickupRow: DataFlowExpression = this.createTemplatableExpression(StringDataFlowType.TYPE, 'any');

    @Metamodel.attribute({
        type: SortExpression.MODEL,
        collection: Collection.Array,
        constraint: {
            unique: true,
            validator: LookupTransformation.validateSortExpressions
        }
    })
    public sortExpressions: SortExpression[] = [];

    private static validateMultipleRow(owner: LookupTransformation, value: DataFlowExpression): IViolation[] {
        return Transformation.validateTemplateExpressions(owner, [value], stringResources.LookupTransformationMultipleRowLabel);
    }

    private static validatePickupRow(owner: LookupTransformation, value: DataFlowExpression): IViolation[] {
        const violations: IViolation[] = Transformation.validateTemplateExpressions(owner, [value], stringResources.LookupTransformationRowToChooseLabel);
        if (owner.multipleRow.expression !== 'true' && owner.pickupRow.expression === '') {
            violations.push({
                context: owner,
                message: () => stringResources.LookupTransformationMissingPickupRow
            });
        }
        return violations;
    }

    private static validateSortExpressions(transformation: LookupTransformation): IViolation[] {
        return transformation.multipleRow.expression !== 'true' && transformation.pickupRow.expression !== 'any' ? SortExpression.validateExpressions(transformation) : undefined;
    }

    public addSortExpression(): SortExpression {
        const sortExpression = Owned.create<SortExpression>(SortExpression.MODEL, this);
        sortExpression.ascending = true;
        sortExpression.nullsFirst = true;
        this.sortExpressions.push(sortExpression);
        return sortExpression;
    }

    protected getGeneratedDescription(): string {
        if (this.inputStreams.length === 2) {
            return format(stringResources.LookupDescription, this.inputStreams[0].qualifiedName, this.inputStreams[1].qualifiedName);
        }
        return stringResources.LookupNoSecondStreamDescription;
    }
}
